export * from "./componentByType";
